import apiClient from "../lib/api-client";

export interface SubscriptionSummary {
  valid: boolean;
  tenantId: string;
  tenantName: string;
  tenantStatus: string;
  subscription: {
    id: string;
    status: string;
    planName: string;
    planType: string;
    features: string[];
    startDate?: string;
    endDate?: string | null;
    renewalDate?: string | null;
    interval?: string;
    amount?: number | null;
  };
  enabledModules: string[];
  limits: {
    maxStores: number;
    maxUsers: number;
    currentStores: number;
    currentUsers: number;
    storageGB?: number;
    usedStorageGB?: number;
  };
  billing?: {
    latestPaymentDate?: string | null;
    latestPaymentStatus?: string | null;
    invoiceNumber?: string | null;
    invoiceAmount?: number | null;
  };
  validUntil: string;
  maxOfflineDays: number;
  validatedAt: string;
}

export const subscriptionInfoService = {
  async getSummary(): Promise<SubscriptionSummary> {
    const response = await apiClient.post("/auth/validate-session");
    return response.data;
  },
};
